import { createContext } from "react";
import { PlantConfigData } from "../../utils/interface";

export interface MainContentInterface {
    selectedPlant?: PlantConfigData
}
export const MainContentContext = createContext<MainContentInterface>({
    selectedPlant: undefined
});